import OperatorService from "@/api/services/operator.service";

const PrioritiesService = {
  getPrioritiesList(params = { page: 1, count: 10 }) {
    return OperatorService.get("/cameras/priorities/transactions", { headers: params });
  },
  addPriority(priority) {
    return OperatorService.post("/cameras/priorities", priority);
  },
  removeTransaction(id_transaction) {
    return OperatorService.delete(`/cameras/priorities/transactions/${id_transaction}`);
  }
}

export default PrioritiesService;
